import "whatwg-fetch";
import { Utilities } from "./utilities";
import { LoadHTML } from "./html-loader";

// janrain
import { LoadJanrainScript } from "./janrain-loader";
import { SetupSettings } from "./janrain-settings";
import { SetupEvents } from "./janrain-events";

// modules
import Modules from "./modules";

export class DigitalIdentityHub implements IDigitalIdentityHub {
  public modules = {};
  public modulesList: IDigitalIdentityHubModule[] = [];
  public translations = {};
  public validations = {};
  public utilities = new Utilities();
  public settings: IDigitalIdentityHubSettings = {
    consentHubCustomerEndpoint: "",
    transactionalEmailsEndpoint: "",
    transactionalEmailsKey: "",
    baseUrl: "",
    consentAcquisitionApiKey: "",
    consentAcquisitionEncKey: "",
    htmlEndpoint: "",
    deeplinkEndpoint: "",
    emailChangeEndpoint: "",
    country: "XX",
    enableFrontEndDeeplinking: true,
    htmlTokens: {
      loginPath: "index.html",
      editProfilePath: "index.html?screenToRender=editProfile",
      registrationPath: "", // This is used in HTML links & SignInEnhancement
      forgotPasswordPath: "index.html?screenToRender=forgotPassword"
    }
  };

  constructor(modulesNames: string[] = Object.keys(Modules)) {
    this.initModules(modulesNames);
  }

  public addModule = (module: IDigitalIdentityHubModule) => {
    this.modulesList.push(module);
    this.modules[module.name] = module;
  };

  public getModulesNames = () => {
    return Object.keys(this.modules);
  };

  public getModule = (name: string) => {
    return this.modules[name];
  };

  public start = async() => {
    await SetupSettings(this.modulesList);
    SetupEvents(this.modulesList);
    await LoadHTML();
    LoadJanrainScript();
  };

  private initModules(modulesNames: string[]) {
    this.modulesList = modulesNames.map(moduleName => new Modules[moduleName]()).filter(module => !!module);

    this.modules = this.modulesList.reduce((acc, current) => {
      if (current.name) {
        acc[current.name] = current;
      }

      return acc;
    }, {});
  }
}
